export default (() => {
  var crypto = typeof window !== 'undefined' && window.crypto;
  if (!(crypto !== null && crypto !== void 0 && crypto.subtle)) {
    return null;
  }
  return string => crypto.subtle.digest('SHA-256', new TextEncoder().encode(string)).then(hashBuffer => Array.from(new Uint8Array(hashBuffer)).map(byte => byte.toString(16).padStart(2, '0')).join(''));
});